import { render, staticRenderFns } from "./index.vue?vue&type=template&id=599fb07c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsDesktop: require('/usr/src/motec/components/products/Desktop.vue').default,ProductsTablet: require('/usr/src/motec/components/products/Tablet.vue').default,ProductsMobile: require('/usr/src/motec/components/products/Mobile.vue').default})
